import styled from 'styled-components';

import { COLORS } from '^/constants/commonStyles';

export const BookingPageWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: visible;
  margin: 48px auto;
  display: flex;
  flex-direction: row;
  gap: 36px;

  @media (max-width: 1024px) {
    padding: 0;
    margin: 0 auto;
  }
`;

export const BookingAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 720px;
  gap: 32px;

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 20px;
  }
  form {
    display: flex;
    flex-direction: column;
    width: 720px;
    gap: 32px;
    width: 720px;
    gap: 32px;
    @media (max-width: 1024px) {
      display: flex;
      flex-direction: column;
      width: 100%;
      /* padding: 20px; */
      gap: 20px;
    }
  }
`;

export const BillAreaContainer = styled.div`
  flex-grow: 1;
  position: relative;
`;

export const CarInfoContainer = styled.div`
  width: 100%;
  max-width: 715px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 30px;
  border-bottom: 1px solid ${COLORS.GRAY_100};
  position: relative;

  @media (max-width: 1024px) {
    width: 100%;
    max-width: inherit;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    padding: 15px 20px;

    border-bottom: 1px solid #eaeaea;
  }
`;

export const CarInfoDetail = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 500px;
`;

export const SectionContainer = styled.div`
  width: 100%;
  max-width: 715px;
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    margin-bottom: 15px;
    max-width: inherit;
    padding: 0 20px;
  }
`;

export const SectionTitle = styled.h1`
  font-size: 22px;
  color: ${COLORS.BLACK};
  font-weight: 700;

  @media (max-width: 1024px) {
    font-size: 18px;
    color: ${COLORS.BLACK};
    font-weight: 700;
    line-height: 18px;
    margin-bottom: 15px;
  }
  .isRequired {
    color: #9f9f9f;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
  }
`;

export const SelectSectionTitle = styled(SectionTitle)`
  display: flex;
  align-items: center;
  gap: 3px;
  margin-bottom: 20px;

  .isRequired {
    color: #9f9f9f;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
    padding-left: 4px;
  }

  @media (max-width: 1024px) {
    font-size: 18px;
    margin-bottom: 20px;
  }
`;

export const CarInfoServiceInfoContainer = styled.div`
  font-size: 14px;
  color: ${COLORS.BLACK};
  font-weight: 300;
  color: #1e1e1e;

  @media (max-width: 1024px) {
    font-size: 12px;
    line-height: 12px; /* 100% */
    margin-top: 5px;
  }
`;

export const VendorImage = styled.img`
  max-width: 116px;
  margin-bottom: 10px;
`;

export const CarImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 200px;
`;

export const CarImage = styled.img`
  margin-top: 30px;
  width: 158px;

  @media (max-width: 1024px) {
    margin-top: 0;
  }
`;

export const TextDescription = styled.span`
  color: ${COLORS.GRAY_500};
  font-size: 12px;
  font-weight: 300;
  line-height: 22px; /* 183.333% */

  .WarningText {
    color: #ef4444;
    text-align: right;
    word-spacing: -1px;
    line-height: 125%;
  }
`;

export const InsuranceContainer = styled.div`
  width: 100%;
  max-width: 715px;
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    max-width: inherit;
  }
`;

export const InsuranceCardContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const InsuranceCautionBanner = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  background-color: #f2f2f2;
  padding: 12px 16px;
  margin-top: 10px;
  border-radius: 5px;
  color: #1e1e1e;
  white-space: pre-line;
`;

export const OptionalServicesContainer = styled.div`
  width: 100%;
  max-width: 715px;
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    max-width: inherit;
  }
`;

export const OptionalServicesList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  margin-bottom: 5px;
`;

export const OptionalServiceItem = styled.div<{
  count: number;
}>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 21px;
  border-radius: 10px;
  border: ${(props) => (props.count > 0 ? `1px solid ${COLORS.BLUE_500}` : '1px solid #D3D3D6')};

  @media (max-width: 1024px) {
    padding: 10px 14px;
  }
`;

export const OptionalServicesLeftContainer = styled.div`
  display: flex;
  align-items: center;
`;
export const OptionalServicesDescriptions = styled.div`
  display: flex;
  margin-left: 8px;
  flex-direction: column;

  @media (max-width: 1024px) {
    margin-left: 11px;
    padding-right: 5px;
  }
`;

export const CounterContainer = styled.div`
  display: flex;
  width: 48px;
  align-items: center;
  gap: 6px;
  font-size: 15px;
`;

interface CounterButtonProps {
  buttonType: 'minus' | 'plus';
  count: number;
  disabled?: boolean;
}
export const CounterButton = styled.button<CounterButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  background-color: ${(props) => {
    if (props.disabled) {
      return 'rgba(217, 217, 217, 0.50)';
    }
    if (props.count <= 0 && props.buttonType === 'minus') {
      return 'rgba(217, 217, 217, 0.50)';
    }
    return 'rgba(255, 255, 255, 0.50)';
  }};
  border-radius: 100px;
  border: 1px solid #d9d9d9;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.7 : 1)};
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ItemTitle = styled.span`
  font-size: 14px;
  color: ${COLORS.BLACK};
  font-weight: 700;
`;

export const ItemDescription = styled.p`
  font-size: 12px;
  color: ${COLORS.BLACK};
  font-weight: 300;
`;

export const DescriptionWithBulletPoint = styled(ItemDescription)`
  padding-left: 10px;
  text-indent: -15px;
`;

export const PickupDropInfoContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 715px;
  flex-direction: column;

  @media (max-width: 1024px) {
    // max-width: inherit;
    padding: 0 20px;
    width: 100%;
  }
`;

export const RentalInfoSummaryContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  gap: 10px;
`;
export const RentalInfoSummaryRow = styled.div`
  display: flex;
  gap: 15px;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 0;
  }
`;

export const RentalInfoSummaryMobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.GRAY_100};
  gap: 9px;
  padding: 10px 24px;
  margin: 0 -24px;
`;

export const RentalInfoLabelContainer = styled.div`
  flex-shrink: 0;
  width: 95px;
  font-weight: bold;
  font-size: 14px;
  // line-height: 26px;
`;

export const RentalInfoDeailContainer = styled.div`
  width: 320px;
  font-size: 14px;
  color: ${COLORS.BLACK};
  font-weight: 300;
  white-space: pre-line;
  word-break: break-all;

  @media (max-width: 1024px) {
    width: 100%;
  }
`;

export const FlightInfoFormContainer = styled.div<{ isGUAMCK?: boolean }>`
  display: grid;
  grid-template-columns: ${(props) => (props.isGUAMCK ? '1fr 1fr' : '1fr')};
  grid-template-rows: 1fr;
  column-gap: 27px;
  row-gap: 10px;
`;

export const ExtraNoticeBox = styled.div<{
  backgroundColor?: string;
  border?: string;
  indent?: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 10px;
  padding: 12px 16px;
  background: ${(props) => (props.backgroundColor ? props.backgroundColor : '#f2f2f2')};
  border: ${(props) => (props.border ? props.border : 'none')};
  border-radius: 5px;
  color: ${COLORS.BLACK};
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;

  & > div {
    padding-left: ${(props) => (props.indent ? '10px' : 0)};
    text-indent: ${(props) => (props.indent ? '-15px' : 0)};
  }
`;

export const CheckBoxLabel = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
`;

// Bill

export const BillBox = styled.div`
  width: 387px;
  padding: 33px;
  position: sticky;
  top: 48px;
  border-radius: 10px;
  border: 1px solid #d3d3d6;
  background: #fff;
`;

export const BillListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 21px 0;

  @media (max-width: 1024px) {
    padding-top: 0;
  }
`;

export const BillList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #d3d3d6;
  border-top: 1px solid #d3d3d6;
  padding: 21px 0;

  @media (max-width: 1024px) {
    border-top: none;
    padding: 10px 0;
    gap: 6px;
  }
`;

export const BillItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .BillItemLabel {
    color: #1e1e1e;
    font-size: 18px;
    font-weight: 400;
    line-height: 22px; /* 122.222% */
    @media (max-width: 1024px) {
      font-size: 16px;
    }
  }

  .BillItemBoldLabel {
    color: #1e1e1e;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px; /* 122.222% */
    @media (max-width: 1024px) {
      font-size: 16px;
    }
  }

  .BillItemPrice {
    color: #1e1e1e;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px; /* 122.222% */
  }

  .BillDiscountItemPrice {
    color: #55a9f3;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px; /* 122.222% */
  }
`;

export const BillOptionalItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: ${COLORS.GRAY_500};
`;

export const BillPpdResultItem = styled.div`
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 1024px) {
    margin-top: 10px;
  }

  .BillPpdResultLabel {
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    @media (max-width: 1024px) {
      font-size: 16px;
      font-weight: 700;
    }
  }

  .BillPpdResultPrice {
    font-size: 25px;
    font-weight: 700;
    line-height: 22px;
    @media (max-width: 1024px) {
      font-size: 18px;
    }
  }

  .BillPpdResultDiscountPrice {
    font-size: 25px;
    font-weight: 700;
    line-height: 22px;
    color: #55a9f3;
    @media (max-width: 1024px) {
      font-size: 18px;
    }
  }
`;

export const BookingButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 7px;
  @media (max-width: 1024px) {
    width: auto;
    padding: 0;
  }
`;

export const BookingButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px 0;
  background-color: ${COLORS.BLUE_500};
  border-radius: 5px;
  color: ${COLORS.WHITE};
  font-weight: 700;
  :disabled {
    background-color: ${COLORS.GRAY_100} !important;
    color: ${COLORS.BLACK} !important;
    pointer-events: none !important;
  }

  @media (max-width: 1024px) {
    padding: 19px 15px;
    margin-top: 0;
  }
`;
